import React from 'react';
import { Link } from 'react-router-dom';

import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useHistory } from 'react-router-dom';

import Notify from '../../../components/Notify/Notify';
import ModalProfileMenu from '../../../components/Modals/ModalProfileMenu/ModalProfileMenu';

import ModalPricingPlanLimit from '../../../components/Modals/ModalPricingPlanLimit/ModalPricingPlanLimit';
import ModalPricingPlanUpgrade from '../../../components/Modals/ModalPricingPlanUpgrade/ModalPricingPlanUpgrade';

import ModalInviteToApp from '../../../components/Modals/ModalInvitePeople/ModalInvitePeople';
import ModalFeedbackThanks from '../../../components/Modals/ModalFeedbackThanks/ModalFeedbackThanks';

import Sidebar from '../_components/Sidebar/Sidebar';
import Header from '../_components/Header/Header';
import PricingPlans from '../_components/PricingPlans/PricingPlans';

import '../MainApp.scss';
import './Subscriptions.scss';

const Subscriptions = () => {
    document.title = 'Subscriptions | DB Design';

    const dispatch = useDispatch();
    const history = useHistory();

    const handleClick = (e) => {
        // history.push(`/diagram/sdf`);
    };

    return (
        <div className="dash-container">
            <Sidebar />
            <div className='dash-main'>

                {/* common modals */}
                <Notify viewType='main' />
                <ModalProfileMenu />

                <ModalPricingPlanLimit />
                <ModalPricingPlanUpgrade />

                <ModalInviteToApp />
                <ModalFeedbackThanks />

                {/* page components */}

                <Header title=''>
                    {/* <button className='dash-main-header-button prime' onClick={(e) => { handleClick(e); }}>Upgrade Plan</button> */}
                </Header>

                <div className='dash-main-body subscriptions'>
                    <div className='dash-main-body-title'>Your current pricing plan is Free. You can use it without any limits. Enjoy it. <span></span></div>

                    <PricingPlans />
                </div>
            </div>
        </div>
    );
};

export default Subscriptions;
